<div class="flex min-h-[calc(100vh-48px)] flex-col gap-5 bg-light-color px-6 py-6 font-base text-dark-color">
  <header class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Perfil</p>
      <h1 class="text-2xl font-semibold leading-tight">Seus dados</h1>
      <p class="max-w-3xl text-sm text-light-color/90">
        Atualize suas informações de acesso e contato para manter seu ambiente configurado corretamente.
      </p>
    </div>
    <div class="grid grid-cols-2 gap-3 text-sm md:grid-cols-2">
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Nome</p>
        <strong class="text-lg">{{ formDataProfile.get('nome')?.value || '--' }}</strong>
      </div>
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Host</p>
        <strong class="text-lg break-all">{{ formDataProfile.get('host')?.value || '--' }}</strong>
      </div>
    </div>
  </header>

  <section class="flex flex-col gap-4 rounded-xl border border-border-color bg-white px-5 py-5 shadow-[0_12px_36px_var(--box-shadow-color)]">
    <form class="grid grid-cols-1 gap-4 md:grid-cols-2" [formGroup]="formDataProfile" (ngSubmit)="onSubmit()">
      <div class="flex flex-col gap-2">
        <label for="profile-name" class="text-sm text-dark-color">Nome</label>
        <input
          type="text"
          id="profile-name"
          class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
          placeholder="Insira o nome"
          formControlName="nome" />
      </div>
      <div class="flex flex-col gap-2">
        <label for="profile-host" class="text-sm text-dark-color">Host</label>
        <input
          type="text"
          id="profile-host"
          class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
          placeholder="EX: https://teste.atenderbem.com"
          formControlName="host" />
      </div>
      <div class="flex flex-col gap-2">
        <label for="profile-phone" class="text-sm text-dark-color">Telefone</label>
        <input
          type="text"
          id="profile-phone"
          class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
          placeholder="(38) 9 9999-9999"
          formControlName="telefone"
          (keyup)="updateMaskPhone()" />
      </div>
      <div class="flex flex-col gap-2">
        <label for="profile-cpf" class="text-sm text-dark-color">CPF</label>
        <input
          type="text"
          id="profile-cpf"
          class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
          placeholder="Ex: 371.384.240-00"
          formControlName="cpfcnpj"
          (keyup)="updateMaskCpfCnpj()" />
      </div>
      <div class="flex flex-col gap-2">
        <label for="profile-password" class="text-sm text-dark-color">Senha</label>
        <input
          type="password"
          id="profile-password"
          class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
          placeholder="Senha"
          formControlName="password" />
        <small class="text-xs text-red-600" *ngIf="formDataProfile.get('password')?.errors?.['minlength']">Insira pelo menos 3 caracteres.</small>
      </div>
      <div class="flex flex-col gap-2">
        <label for="profile-confirm-password" class="text-sm text-dark-color">Confirmar senha</label>
        <input
          type="password"
          id="profile-confirm-password"
          class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
          placeholder="Confirmar senha"
          formControlName="confirmarSenha" />
        <small class="text-xs text-red-600" *ngIf="formDataProfile.errors?.['passwordMismatch']">As senhas não coincidem.</small>
      </div>

      <div class="col-span-1 md:col-span-2 text-sm text-dark-color/80">
        Para aplicar as novas configurações, digite a senha e confirme a mesma.
      </div>

      <div class="col-span-1 md:col-span-2 flex justify-end">
        <button
          type="submit"
          class="rounded-base bg-primary-color px-5 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-70"
          [disabled]="formDataProfile.errors?.['passwordMismatch'] || formDataProfile.get('password')?.errors?.['minlength'] || formDataProfile.get('password')?.errors?.['required']">
          Salvar
        </button>
      </div>
    </form>
  </section>
</div>

<app-loading-modal></app-loading-modal>
<app-alert></app-alert>
